import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import MisHeader from '../../Components/MisHeader'
import UserShield from '../../Components/UserShield'

import * as utils from '../../Ranking/ranking.utils'

/**
 *  Pop up showed when you have finished the game
 */
class StartBattle extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      growOutClass: '',
    }
  }

  startBattle() {
    const { getBattleQuestion, removeScreen, addScreen, removePopup } = this.props

    getBattleQuestion()
    removePopup('tile_popup')
    this.setState({ growOutClass: 'bounceOut-animation' })
    setTimeout(() => {
      removeScreen('start_battle_screen')
      addScreen('battle_screen')
    }, 1000)
  }

  renderData(shieldPosition, user) {
    const { currentUser, rankingObfuscated } = this.props
    const cityLevel = 'map.buildings.city_level.' + (user.cityLevel ? user.cityLevel : 1)
    let obfuscated = rankingObfuscated == 'undefined' ? 'normal' : rankingObfuscated
    let name =
      (obfuscated == 'obfuscated'
        ? utils.obfuscated(user.name, currentUser)
        : obfuscated == 'alias'
        ? user.name == currentUser.name
          ? user.name
          : user.alias
        : user.name) || 'name'
    return (
      <div className="mis--players__item">
        {shieldPosition == 'right' ? <UserShield shield={user.colonyShield} /> : null}
        <ul className="data">
          <li>
            <FormattedMessage id={cityLevel} />
          </li>
          <li className="data--name">{user.colonyName}</li>
          <li>{name}</li>
        </ul>
        {shieldPosition == 'left' ? <UserShield shield={user.colonyShield} /> : null}
      </div>
    )
  }

  render() {
    const {
      removeScreen,
      giveUp,
      currentUser,
      individualBattle,
      intl,
      rivalInfo,
      battle,
      addHowlSound,
      hideTabs,
    } = this.props
    const { growOutClass } = this.state
    const usingBattle = individualBattle ? individualBattle : battle
    const { helpBtn, settingsBtn } = hideTabs || {}
    if (!usingBattle) {
      return null
    }
    const building = usingBattle.building
    const buildingName = intl.formatMessage({ id: `buildings.${building.name}` })

    return (
      <div
        className={`container ${growOutClass} ${
          !growOutClass ? 'growIn-animation' : ''
        } background background--mina z-index1`}
      >
        <div className="content">
          <div className="mis">
            <MisHeader helpBtn={helpBtn} settingsBtn={settingsBtn} />
            <div className="mis--challenge__confirmation">
              <h1 className="h1">
                <span className="icon-desafio"> </span>
                <span>
                  <FormattedMessage id={'battles.title'} />
                </span>
                <span className="icon-desafio"> </span>
              </h1>
              <div className="mis--challenge__info">
                <div className="title">
                  {' '}
                  <FormattedMessage
                    id={'battles.bet'}
                    values={{ name: buildingName, level: building.level }}
                  />
                </div>
                <div className="mis--players">
                  {this.renderData(
                    'left',
                    currentUser.id == usingBattle.createdBy ? currentUser : rivalInfo
                  )}
                  {this.renderData(
                    'right',
                    currentUser.id != usingBattle.createdBy ? currentUser : rivalInfo
                  )}
                </div>
                <div
                  onClick={() => {
                    {
                      this.startBattle()
                      addHowlSound('button_click')
                    }
                  }}
                  className="btn--shape shape--orange"
                >
                  <div className="btn--shape__canvas">
                    <FormattedMessage id={'battles.start'} />
                  </div>
                </div>
                <p
                  onClick={() => {
                    giveUp()
                    addHowlSound('button_click')
                    this.setState({ growOutClass: 'bounceOut-animation' })
                    setTimeout(() => removeScreen('start_battle_screen'), 1000)
                  }}
                  className="btn--link"
                >
                  <FormattedMessage id={'battles.giveUp'} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

StartBattle.propTypes = {
  currentUser: PropTypes.object,
  getBattleQuestion: PropTypes.func,
  removePopup: PropTypes.func,
  individualBattle: PropTypes.object,
  giveUp: PropTypes.func,
  removeScreen: PropTypes.func,
  addScreen: PropTypes.func,
  rivalInfo: PropTypes.object,
  battle: PropTypes.object,
  addHowlSound: PropTypes.func,
  hideTabs: PropTypes.object,
  rankingObfuscated: PropTypes.string,
}

export default StartBattle
